export default __webpack_public_path__ + "static/media/ceo.18df9985.jpeg";